import { Box, Typography } from "@outschool/backpack";
import { Container } from "@outschool/ui-legacy-component-library";
import React from "react";

import TopicLink from "./TopicLink";
import { TopicInfo } from "./Topics";

type Props = {
  title: string;
  topics: TopicInfo[];
  maxTopicsNum?: number;
};

export function MobileTopicSection({ title, topics, maxTopicsNum }: Props) {
  const topicList = maxTopicsNum ? topics.slice(0, maxTopicsNum) : topics;

  return (
    <Container sx={{ marginTop: "4rem" }}>
      <Box
        flex
        sx={{
          flexDirection: "column",
          py: 0,
          alignItems: "left",
          overflow: "auto",
        }}
      ></Box>
      <Typography emphasized variant="h6" pb="1em">
        {title}
      </Typography>
      <Box
        flex
        sx={{
          flexWrap: "wrap",
          width: "100%",
          justifyContent: "left",
          gap: "8px",
        }}
      >
        {topicList.map(topic => (
          <TopicLink
            topic={topic}
            key={topic.title}
            topicSx={{ fontWeight: 400, whiteSpace: "normal" }}
          />
        ))}
      </Box>
    </Container>
  );
}
